/**
 * Version
 *
 * Reusable component for ALP version data.
 */

import React from 'react';
import { DetailHeader, InputField, SelectField } from 'cx-ui-components';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getActiveAction } from '../../../../redux/modules/entities/alps/selectors';
import store from '../../../../redux/store';

const SectionExplanation = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
`;

const Counter = styled.div`
    display:flex;
    flex:1;
`;

const ExpirationTimeContainer = styled(InputField)``;

export default function VersionSection({ actionTypes, disabled, activeAction,callFrom="Create", activeActionFromInit=""}) {
  return (
    <React.Fragment>
      <DetailHeader text="Active Storage Retention" />
      <SectionExplanation>Active Storage provides immediate access to artifacts.</SectionExplanation>
      <SelectField
        name="activeAction"
        label="Action *"
        placeholder="Select action..."
        data-automation="actionList"
        disabled={disabled}
        onChange={(val, n, o) => { store.dispatch({ type: 'CHECK_ACTIVE_ACTION', newValue: n }) }}
        options={[
          {
            label: 'Select action...',
            value: '',
          },
          ...actionTypes,
        ]}
        required
      />
      
      { ((activeAction == "Delete" && callFrom == "Create")  || (activeActionFromInit == "Delete" && callFrom == "updateVersion" )) &&
        <Counter>
          <ExpirationTimeContainer
            name="activeDuration"
            label="After *"
            minValue="1"
            maxValue="9999"
            disabled={disabled}
            dataType="number"
            required
          />
          <SectionExplanation>days from the interaction's End Date</SectionExplanation>
        </Counter>
      }

      {/* <!-- <DetailHeader text="Archive Storage Retention" />
      <SectionExplanation>For long-term data archiving that is accessed once or twice in a year at most and can be restored within 12-hours. Storage price is significantly lower than Active Storage.</SectionExplanation>
      <SelectField
        name="archiveAction"
        label="Action *"
        placeholder="Select action..."
        data-automation="actionList"
        disabled={disabled}
        options={[
          {
            label: 'Select action...',
            value: '',
          },
          ...actionTypes,
        ]}
        required
      />
      <Counter>
        <ExpirationTimeContainer
          name="archiveDuration"
          label="After *"
          minValue="1"
        maxValue="9999"
          disabled={disabled}
          dataType="number"
          required
        />
        <SectionExplanation>days from the interaction's End Date</SectionExplanation>
      </Counter>--> */}
    </React.Fragment>
  );
}

VersionSection.propTypes = {
  actionTypes: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};
